import DailyReportService from 'src/modules/dailyReport/dailyReportService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'DAILYREPORT_VIEW';

const dailyReportViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dailyReportViewActions.FIND_STARTED,
      });

      const record = await DailyReportService.find(id);

      dispatch({
        type: dailyReportViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dailyReportViewActions.FIND_ERROR,
      });

      getHistory().push('/daily-report');
    }
  },
};

export default dailyReportViewActions;
